/**
 * Необходимо подключить parsleyjs, inputmask, ladda и jquery-toast-plugin сюда и в ксс через npm
 */

import Parsley from "parsleyjs";
import * as Ladda from 'ladda';
require("parsleyjs/dist/i18n/ru");
require("inputmask/dist/jquery.inputmask.bundle");
require("jquery-toast-plugin");

export default class Form {
    constructor(selectorForm, formConfig = {}, ajaxConfig = {}, doneClosure, failClosure) {
        this.form = $(selectorForm);
        if(this.form.length === 0) {
            console.warn('Форма ' + selectorForm + ' не найдена');
        }
        this.ajaxConfig = Object.assign({
            method: 'POST',
            cache: false,
            contentType: false,
            processData: false,
        }, ajaxConfig);
        this.formConfig = Object.assign({
            blockAfterSend: true,
            buttonAnimation: true,
        }, formConfig);
        this.doneClosure = doneClosure ? doneClosure : function(response) {
            if(response.status === true) {
                $.toast({
                    icon: 'success',
                    position: 'mid-center',
                    hideAfter: 3000,
                    showHideTransition: 'slide',
                    heading: 'Успешно!',
                    text: 'Форма успешно отправлена!'
                });
            } else {
                $.toast({
                    icon: 'error',
                    position: 'mid-center',
                    hideAfter: 3000,
                    showHideTransition: 'slide',
                    heading: 'Ошибка!',
                    text: 'При отправке формы произошла ошибка. ' +
                    'Пожалуйста, повторите попытку или свяжитесь с администратором.'
                });
            }
        };
        this.failClosure = failClosure ? failClosure : function(response) {
            $.toast({
                icon: 'error',
                position: 'mid-center',
                hideAfter: 3000,
                showHideTransition: 'slide',
                heading: 'Ошибка!',
                text: 'При отправке формы произошла ошибка. ' +
                'Пожалуйста, повторите попытку или свяжитесь с администратором.'
            });
        };
        this.init();
    }

    configParsley() {
        Parsley.addValidator('tel', {
            requirementType: 'string',
            validateString: function validateString(value, requirement) {
                let p = value.replace(/\D+/g, "");
                return p.length === 11;
            },
            messages: {
                ru: 'Некорректный номер телефона',
                en: 'Incorrect phone number'
            }
        });
    }

    configForm() {
        if(this.form) {
            this.form.find('input[type=tel]').each(function(i, el) {
                let phone = $(this);
                $(phone).inputmask({
                    mask: '+7 (999) 999-99-99',
                    showMaskOnHover: false
                });
            });
        }
        if(this.formConfig.blockAfterSend) {
            this.formConfig.block = false;
        }
        if(this.formConfig.buttonAnimation) {
            this.buttonAction = Ladda.create( this.form.find('button')[0]);
        }
    }

    init() {
        this.configParsley();
        this.configForm();
        if(this.form) {
            $(this.form.eq(0)).parsley();
            this.form.on('submit', (e) => {
                e.preventDefault();
                let form = $(e.target),
                    data = new FormData(e.target);
                this.ajaxConfig.data = data;
                if(this.formConfig.blockAfterSend && this.formConfig.block === false) {
                    if(this.formConfig.buttonAnimation) {
                        this.buttonAction.start();
                    }
                    $.ajax(this.ajaxConfig)
                        .done(this.doneClosure)
                        .fail(this.failClosure)
                        .always((response) => {
                            if(this.formConfig.buttonAnimation) {
                                this.buttonAction.stop();
                            }
                            if(response.status && response.status === true && this.formConfig.blockAfterSend) {
                                this.formConfig.block = true;
                            }
                        })
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// resources/assets/src/js/form.js